/**
* AssetLibrary.js
* 
* Created on 1-okt-2013, 15:04:03
*
* @author Ivo Swartjes for Ranj
**/

import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class AssetLibrary {
    constructor() {
        this._assets = {};
    };

    getAsset(id) {
        return this._assets[id];
    }

    hasAsset(id) {
        return !isNull(this._assets[id]);
    }

    addAsset(id, asset) {
        this._assets[id] = asset;
    }
}